import { formatNumber } from 'libphonenumber-js'
import PropTypes from 'prop-types'
import React from 'react'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { compose } from 'recompose'
import * as yup from 'yup'
import { doLogin, updateUser } from '../actions/AuthAction'
import { getPhaseInformation } from '../actions/FlowAction'
import { Button, ErrorText, Form, Label, PasswordField, Stack, Validator } from '../components'
import * as routeService from '../services/routeService'
import * as translationService from '../services/translationService'
import { REQUIRED_FIELD } from './../utils/validation/constants'
import AuthContent from './AuthContent'

class LoginPasswordView extends React.Component {
  static propTypes = {
    mobileNumber: PropTypes.string,
    email: PropTypes.string,
    error: PropTypes.any,
    doLogin: PropTypes.func,
    getPhaseInformation: PropTypes.func,
    property: PropTypes.any,
    phaseInformationError: PropTypes.any,
    applicationProfileError: PropTypes.any,
  }

  validation = [
    {
      id: 'password',
      validation: yup.string().required(REQUIRED_FIELD),
    },
  ]

  state = {
    // password: process.env.REACT_APP_DEFAULT_PASSWORD || '',
    password: '',
    inputValidation: {},
  }

  onValueChange = event => {
    const { id, value } = event.target
    this.setState({
      [id]: value,
    })
  }

  resetErrors = () => {
    this.setState({
      inputValidation: {},
    })
  }

  doLogin = async event => {
    event.preventDefault()
    this.resetErrors()

    try {
      await Validator(this.validation, this.state)
      await this.props.doLogin(this.props.mobileNumber.replace(/\s/g, ''), this.state.password, this.props.email)

      routeService.goToPath(routeService.getPrefixPath() + '/')
    } catch (validationErrors) {
      this.setState({
        inputValidation: validationErrors,
      })
    }
  }

  goToPasswordReset = event => {
    event.preventDefault()
    routeService.goToForgotPasswordPage()
  }

  componentDidMount() {
    if (!this.props.mobileNumber) {
      routeService.goToLoginPage()
    }
  }

  render() {
    const { error, phaseInformationError, applicationProfileError, mobileNumber } = this.props
    const { inputValidation } = this.state

    let errorMessage = undefined
    if (error) {
      try {
        if (error.message) {
          errorMessage = error.message
        } else {
          errorMessage = translationService.loginPasswordFailedAuthentication()
        }
      } catch (x) {
        errorMessage = translationService.loginPasswordFailedAuthentication()
      }
    }

    return (
      <AuthContent
        title={translationService.loginPasswordTitle()}
        subtitle={translationService.loginPasswordSubTitle()}
        hasToken={false}>
        <Form onSubmit={this.doLogin}>
          {(phaseInformationError || applicationProfileError) && (
            <ErrorText>{translationService.generalError()}</ErrorText>
          )}

          {mobileNumber && (
            <div>
              <Label>{translationService.enteredMobileNumberPlaceholder()}</Label>
              <Stack distribution="EqualSpacing">
                <Stack.Item>
                  <strong>{formatNumber(mobileNumber, 'International')}</strong>
                </Stack.Item>
                <Stack.Item>
                  <Link to={`${routeService.getPrefixPath()}/login`}>{translationService.system('edit')}</Link>
                </Stack.Item>
              </Stack>
            </div>
          )}

          <PasswordField
            label={translationService.loginPasswordPasswordLabel()}
            id="password"
            autoFocus
            value={this.state.password}
            onChange={this.onValueChange}
            error={inputValidation.password || errorMessage}
          />
          <Button primary submit onClick={this.doLogin}>
            {translationService.system('next')}
          </Button>
          <div>
            <Button plain onClick={this.goToPasswordReset}>
              {translationService.LoginPasswordForgetText()}
            </Button>
          </div>
        </Form>
      </AuthContent>
    )
  }
}

const mapStateToProps = ({ AuthReducer, FlowReducer }) => {
  const { user = {}, error } = AuthReducer
  const { phaseInformationError, applicationProfileError, property } = FlowReducer
  const { mobileNumber, email } = user
  return {
    mobileNumber,
    email,
    error,
    phaseInformationError,
    applicationProfileError,
    property,
  }
}

const mapDispatchToProps = dispatch => ({
  mobileNumberChange: mobileNumber => dispatch(updateUser({ mobileNumber })),
  doLogin: (mobileNumber, password, email) => dispatch(doLogin(mobileNumber, password, email)),
  getPhaseInformation: (userId, propertyInfoId, token) =>
    dispatch(getPhaseInformation({ userId, propertyInfoId, token })),
})

export default compose(
  translate('translations'),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(LoginPasswordView)



// WEBPACK FOOTER //
// ./src/views/LoginPasswordView.js